'use client';

import { createClient } from '@/lib/supabase/client';

export type HubNotificationType =
  | 'contribution_approved' |'contribution_rejected' |'corroboration_received' |'rank_changed' |'new_topic';

export interface HubNotification {
  id: string;
  recipientId: string;
  type: HubNotificationType;
  title: string;
  body: string | null;
  link: string | null;
  metadata: Record<string, any>;
  readAt: string | null;
  createdAt: string;
}

function mapRow(row: any): HubNotification {
  return {
    id: row.id,
    recipientId: row.recipient_id,
    type: row.type as HubNotificationType,
    title: row.title,
    body: row.body ?? null,
    link: row.link ?? null,
    metadata: row.metadata ?? {},
    readAt: row.read_at ?? null,
    createdAt: row.created_at,
  };
}

export async function fetchHubNotifications(userId: string): Promise<HubNotification[]> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('hub_notifications')
    .select('*')
    .eq('recipient_id', userId)
    .order('created_at', { ascending: false })
    .limit(50);

  if (error) {
    console.error('fetchHubNotifications error:', error.message);
    return [];
  }
  return (data || []).map(mapRow);
}

export async function markHubNotificationRead(id: string): Promise<void> {
  const supabase = createClient();
  await supabase
    .from('hub_notifications')
    .update({ read_at: new Date().toISOString() })
    .eq('id', id);
}

export async function markAllHubNotificationsRead(userId: string): Promise<void> {
  const supabase = createClient();
  await supabase
    .from('hub_notifications')
    .update({ read_at: new Date().toISOString() })
    .eq('recipient_id', userId)
    .is('read_at', null);
}

export async function createHubNotification(params: {
  recipientId: string;
  type: HubNotificationType;
  title: string;
  body?: string;
  link?: string;
  metadata?: Record<string, any>;
}): Promise<void> {
  const supabase = createClient();
  const { error } = await supabase.from('hub_notifications').insert({
    recipient_id: params.recipientId,
    type: params.type,
    title: params.title,
    body: params.body ?? null,
    link: params.link ?? null,
    metadata: params.metadata ?? {},
  });
  if (error) {
    console.error('createHubNotification error:', error.message);
  }
}
